import { render } from "./403.vue?vue&type=template&id=8231b444"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/403.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8231b444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8231b444', __exports__)) {
    console.log('reload')
    api.reload('8231b444', __exports__)
  }
  
  module.hot.accept("./403.vue?vue&type=template&id=8231b444", () => {
    console.log('re-render')
    api.rerender('8231b444', render)
  })

}


export default __exports__